<template>
    <div class="container-fluid">
        <loading
            :active.sync="isLoading"
            :can-cancel="false"
            loader="dots"
            :is-full-page="fullPage"
            :height="height"
            :width="width"
            background-color="#6b6969"
        ></loading>
        <div class="row">
            <div class="col-lg-7">
                <div class="row">
                    <div class="col-md-8 offset-md-2" style="margin-top: 2rem;">
                        <h5 class="text-capitalize font-weight-bold cursor-pointer">
                            <a @click="$router.go(-1)" class="text-orange"><i class="fa fa-arrow-left text-orange"></i>
                                Back
                            </a>
                        </h5>
                    </div>
                    <div class="col-12 text-center mt-2 mb-5">
                        <h1 class="text-green font-weight-bold mt-0 h1">
                            Ghana Startup Summit
                        </h1>
                        <h3 class="font-weight-bold text-dark">Exhibitors Registration</h3>
                    </div>
                </div>
                <form class="col-md-6 text-dark" @submit.prevent="postRegistration">
                    <section>
                        <div class="form-group">
                            <label for>Name of organization/startup</label><sup class="text-danger">*</sup>
                            <input type="text" required v-model="data.organisation_name"
                                   class="form-control"/>
                        </div>
                        <div class="form-group">
                            <label for>Year of organization establishment:</label><sup class="text-danger">*</sup>
                            <input type="text" required id="datetimepicker"
                                   class="form-control datepicker"/>
                        </div>
                        <div class="form-group">
                            <label for>Company website:</label><sup class="text-danger">*</sup>
                            <input type="text" required v-model="data.company_website"
                                   class="form-control"/>
                        </div>
                        <div class="form-group">
                            <label for>Name of founder:</label><sup class="text-danger">*</sup>
                            <input type="text" required v-model="data.founder_name"
                                   class="form-control"/>
                        </div>
                        <div class="form-group">
                            <label for>Name of exhibitor:</label><sup class="text-danger">*</sup>
                            <input type="text" required v-model="data.exhibitor_name"
                                   class="form-control"/>
                        </div>
                        <div class="form-group">
                            <label for>Exhibitor’s phone number:</label><sup class="text-danger">*</sup>
                            <input type="text" required v-model="data.exhibitor_phone"
                                   class="form-control"/>
                        </div>

                        <div class="form-group">
                            <label for>Exhibitor’s email:</label><sup class="text-danger">*</sup>
                            <input type="email" required v-model="data.exhibitor_email"
                                   class="form-control"/>
                        </div>
                        <div class="form-group">
                            <label for>LinkedIn profile link:</label>
                            <input type="text" v-model="data.linkedin_profile"
                                   class="form-control"/>
                        </div>

                        <div class="form-group">
                            <label for>Organization/startup profile:</label>
                            <textarea class="form-control mt-4" rows="4" required v-model="data.organisation_profile"
                                      style="resize: vertical;"> </textarea>
                        </div>

                        <div class="form-group">
                            <label for>Industry/sector of organization/startup:</label><sup class="text-danger">*</sup>
                            <select class="form-control" required v-model="data.organisation_sector">
                                <option value="Agriculture (Agtech)">Agriculture (Agtech)</option>
                                <option value="Health">Health</option>
                                <option value="Fintech">Fintech</option>
                                <option value="Education (Edtech)">Education (Edtech)</option>
                                <option value="Food production and sales">Food production and sales</option>
                                <option value="Transport">Transport</option>
                                <option value="IT services">IT services</option>
                                <option value="Waste Management">Waste Management</option>
                                <option value="Manufacturing">Manufacturing</option>
                                <option value="Entertainment">Entertainment</option>
                                <option value="Other">Other</option>
                            </select>
                        </div>
                        <div class="form-group" v-if="data.organisation_sector =='other'">
                            <label for>Provide sector, if other:</label><sup class="text-danger">*</sup>
                            <input type="text" v-model="data.organisation_sector" required
                                   class="form-control"/>
                        </div>
                        <div class="form-group">
                            <label for>Would you come alone:</label><sup class="text-danger">*</sup>
                            <select class="form-control" required v-model="data.coming_alone">
                                <option :value="o.value" v-for="(o,i) in option" :key="i">{{o.data}}</option>
                            </select>
                        </div>
                        <div class="form-group" v-if="!data.coming_alone">
                            <label for>How many people will you come along with:</label><sup class="text-danger">*</sup>
                            <input type="number" v-model="data.people_coming_along" min="1" required
                                   class="form-control"/>
                        </div>
                        <div class="form-group">
                            <label for>Is it your first time attending event:</label><sup class="text-danger">*</sup>
                            <select class="form-control" required v-model="data.first_time_attending">
                                <option :value="o.value" v-for="(o,i) in option" :key="i">{{o.data}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for>Any special exhibition request:</label>
                            <textarea class="form-control mt-4" rows="4" v-model="data.special_request"
                                      style="resize: vertical;"> </textarea>
                        </div>
                    </section>
                    <div class="d-flex justify-content-center">
                        <button
                            class="btn btn-orange pl-5 pr-5" style="font-size: 15px"
                            type="submit"
                        >
                            Submit
                        </button>
                    </div>
                    <div class="text-center mt-2" style="font-weight: 600; margin-bottom: 3rem">Register as an
                        <router-link
                            to="/audience-form"
                            class="text-orange">attendee
                        </router-link>
                    </div>
                </form>
            </div>
            <div class="col-lg-5 ">
                <div class="row sticky-top">
                    <div class="col-md-12">
                        <img src="../assets/1.png" class="img-fluid w-100 pl-md-5 d-none d-md-block  d-lg-block" alt="">
                        <div style="padding-top: 70px; margin-top: -50px;" class="bg-orange text-light side">
                            <div class="ml-md-5 ml-3 pb-4">
                                <span class="mr-5">Follow us</span> <span class="social bg-orange"><i
                                class="fa fa-facebook"></i></span> <span class="social bg-orange"><i
                                class="fa fa-twitter"></i></span><span
                                class="social bg-orange"><i class="fa fa-instagram"></i></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    /* eslint-disable */
    import $ from "jquery";
    import axios from "axios";
    import "vue-loading-overlay/dist/vue-loading.css";
    import Swal from "sweetalert2";


    export default {
        name: "ScholarshipForm",
        data() {
            return {
                isLoading: false,
                fullPage: true,
                height: 128,
                width: 128,
                userInfo: this.$store.state.userInfo,
                option: [{data: 'Yes', value: true}, {data: 'No', value: false}],
                data: {
                    organisation_name: '',
                    year_established: '',
                    company_website: '',
                    founder_name: '',
                    exhibitor_name: '',
                    exhibitor_phone: '',
                    exhibitor_email: '',
                    linkedin_profile: '',
                    organisation_profile: '',
                    organisation_sector: 'IT services',
                    coming_alone: false,
                    people_coming_along: 1,
                    first_time_attending: true,
                    special_request: ''
                },
            };
        },
        components: {
            Loading: () => import('vue-loading-overlay'),
        },
        methods: {
            postRegistration() {
                if (!this.data.coming_alone) {
                    this.data.people_coming_along = ''
                }
                this.isLoading = true;
                this.data.year_established = document.getElementById('datetimepicker').value;
                axios.post(`https://7dr330f2nd.execute-api.us-east-1.amazonaws.com/prod/response`, {
                    response: this.data,
                    id: 'ghana-startup-summit-exhibitors-registration'
                }).then((res) => {
                    console.log(res)
                    Swal.fire({
                        title: "Success!",
                        text: "Registration as an exhibitor has been submitted successfully...",
                        icon: "success",
                        confirmButtonText: "ok"
                    }).then((result) => {
                        if (result) {
                            this.$router.push('/')
                        }
                    });
                }).catch((err) => {
                    Swal.fire({
                        title: "Error!",
                        text: "Error whiles submitting your registration...",
                        icon: "error",
                        confirmButtonText: "ok"
                    });
                }).finally(() => {
                    this.isLoading = false;
                })
            },
        },
        created() {
            document.title = 'Exhibitors Registration || Ghana Startup Summit';
            this.$loadScript("/assets/js/bootstrap-datetimepicker.js")
                .then(() => {
                    datePicker();
                })
        },
    };
</script>

<style scoped>
    .container-fluid {
        height: 100vh;
    }

    form {
        width: 80%;
        margin: 0 auto;
    }

    .form-control {
        background: rgba(228, 228, 228, 0.5);
        padding-left: 10px !important;
    }

    @media screen and (max-width: 599px) and (min-width: 300px) {
        .h1 {
            font-size: 2rem !important;
        }

        .side {
            text-align: center;
            padding-top: 20px !important;
            margin-top: 0px !important;
        }

    }

    /* upload */

    .fileInput + label {
        font-size: 0.9375em;
        color: var(--blue);
    }

    .text-center label {
        border-bottom: 1px solid #0599a9;
        width: 27%;
    }

    .text-center label:hover {
        cursor: pointer;
    }

    section > div > label {
        color: black !important;
        font-size: 16.5px !important;
        margin-bottom: 0.6rem !important;
    }

    section > div textarea {
        height: 60px;
        padding: 0.4rem;
    }

    .social {
        padding: 3px 5px 1px;
        border-radius: 5px;
        border: 1px solid #ffffff;
        margin-right: 25px;
    }


    /*!
 * Datepicker for Bootstrap v1.9.0 (https://github.com/uxsolutions/bootstrap-datepicker)
 *
 * Licensed under the Apache License v2.0 (http://www.apache.org/licenses/LICENSE-2.0)
 */

    .datepicker {
        border-radius: 4px;
        direction: ltr;
    }

    .datepicker-inline {
        width: 220px;
    }

    .datepicker-rtl {
        direction: rtl;
    }

    .datepicker-rtl.dropdown-menu {
        left: auto;
    }

    .datepicker-rtl table tr td span {
        float: right;
    }

    .datepicker-dropdown {
        top: 0;
        left: 0;
        padding: 4px;
    }

    .datepicker-dropdown:before {
        content: '';
        display: inline-block;
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;
        border-bottom: 7px solid rgba(0, 0, 0, 0.15);
        border-top: 0;
        border-bottom-color: rgba(0, 0, 0, 0.2);
        position: absolute;
    }

    .datepicker-dropdown:after {
        content: '';
        display: inline-block;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-bottom: 6px solid #fff;
        border-top: 0;
        position: absolute;
    }

    .datepicker-dropdown.datepicker-orient-left:before {
        left: 6px;
    }

    .datepicker-dropdown.datepicker-orient-left:after {
        left: 7px;
    }

    .datepicker-dropdown.datepicker-orient-right:before {
        right: 6px;
    }

    .datepicker-dropdown.datepicker-orient-right:after {
        right: 7px;
    }

    .datepicker-dropdown.datepicker-orient-bottom:before {
        top: -7px;
    }

    .datepicker-dropdown.datepicker-orient-bottom:after {
        top: -6px;
    }

    .datepicker-dropdown.datepicker-orient-top:before {
        bottom: -7px;
        border-bottom: 0;
        border-top: 7px solid rgba(0, 0, 0, 0.15);
    }

    .datepicker-dropdown.datepicker-orient-top:after {
        bottom: -6px;
        border-bottom: 0;
        border-top: 6px solid #fff;
    }

    .datepicker table {
        margin: 0;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .datepicker table tr td,
    .datepicker table tr th {
        text-align: center;
        width: 30px;
        height: 30px;
        border-radius: 4px;
        border: none;
        color: black;
    }

    .table-striped .datepicker table tr td,
    .table-striped .datepicker table tr th {
        background-color: transparent;
    }

    .datepicker table tr td.old,
    .datepicker table tr td.new {
        color: #777777;
    }

    .datepicker table tr td.day:hover,
    .datepicker table tr td.focused {
        background: #eeeeee;
        cursor: pointer;
    }

    .datepicker table tr td.disabled,
    .datepicker table tr td.disabled:hover {
        background: none;
        color: #c7c7c7;
        cursor: default;
    }

    .datepicker table tr td.highlighted {
        color: #000;
        background-color: #d9edf7;
        border-color: #85c5e5;
        border-radius: 0;
    }

    .datepicker table tr td.highlighted:focus,
    .datepicker table tr td.highlighted.focus {
        color: #000;
        background-color: #afd9ee;
        border-color: #298fc2;
    }

    .datepicker table tr td.highlighted:hover {
        color: #000;
        background-color: #afd9ee;
        border-color: #52addb;
    }

    .datepicker table tr td.highlighted:active,
    .datepicker table tr td.highlighted.active {
        color: #000;
        background-color: #afd9ee;
        border-color: #52addb;
    }

    .datepicker table tr td.highlighted:active:hover,
    .datepicker table tr td.highlighted.active:hover,
    .datepicker table tr td.highlighted:active:focus,
    .datepicker table tr td.highlighted.active:focus,
    .datepicker table tr td.highlighted:active.focus,
    .datepicker table tr td.highlighted.active.focus {
        color: #000;
        background-color: #91cbe8;
        border-color: #298fc2;
    }

    .datepicker table tr td.highlighted.disabled:hover,
    .datepicker table tr td.highlighted[disabled]:hover,
    fieldset[disabled] .datepicker table tr td.highlighted:hover,
    .datepicker table tr td.highlighted.disabled:focus,
    .datepicker table tr td.highlighted[disabled]:focus,
    fieldset[disabled] .datepicker table tr td.highlighted:focus,
    .datepicker table tr td.highlighted.disabled.focus,
    .datepicker table tr td.highlighted[disabled].focus,
    fieldset[disabled] .datepicker table tr td.highlighted.focus {
        background-color: #d9edf7;
        border-color: #85c5e5;
    }

    .datepicker table tr td.highlighted.focused {
        background: #afd9ee;
    }

    .datepicker table tr td.highlighted.disabled,
    .datepicker table tr td.highlighted.disabled:active {
        background: #d9edf7;
        color: #777777;
    }

    .datepicker table tr td.today {
        color: #000;
        background-color: #ffdb99;
        border-color: #ffb733;
    }

    .datepicker table tr td.today:focus,
    .datepicker table tr td.today.focus {
        color: #000;
        background-color: #ffc966;
        border-color: #b37400;
    }

    .datepicker table tr td.today:hover {
        color: #000;
        background-color: #ffc966;
        border-color: #f59e00;
    }

    .datepicker table tr td.today:active,
    .datepicker table tr td.today.active {
        color: #000;
        background-color: #ffc966;
        border-color: #f59e00;
    }

    .datepicker table tr td.today:active:hover,
    .datepicker table tr td.today.active:hover,
    .datepicker table tr td.today:active:focus,
    .datepicker table tr td.today.active:focus,
    .datepicker table tr td.today:active.focus,
    .datepicker table tr td.today.active.focus {
        color: #000;
        background-color: #ffbc42;
        border-color: #b37400;
    }

    .datepicker table tr td.today.disabled:hover,
    .datepicker table tr td.today[disabled]:hover,
    fieldset[disabled] .datepicker table tr td.today:hover,
    .datepicker table tr td.today.disabled:focus,
    .datepicker table tr td.today[disabled]:focus,
    fieldset[disabled] .datepicker table tr td.today:focus,
    .datepicker table tr td.today.disabled.focus,
    .datepicker table tr td.today[disabled].focus,
    fieldset[disabled] .datepicker table tr td.today.focus {
        background-color: #ffdb99;
        border-color: #ffb733;
    }

    .datepicker table tr td.today.focused {
        background: #ffc966;
    }

    .datepicker table tr td.today.disabled,
    .datepicker table tr td.today.disabled:active {
        background: #ffdb99;
        color: #777777;
    }

    .datepicker table tr td.range {
        color: #000;
        background-color: #eeeeee;
        border-color: #bbbbbb;
        border-radius: 0;
    }

    .datepicker table tr td.range:focus,
    .datepicker table tr td.range.focus {
        color: #000;
        background-color: #d5d5d5;
        border-color: #7c7c7c;
    }

    .datepicker table tr td.range:hover {
        color: #000;
        background-color: #d5d5d5;
        border-color: #9d9d9d;
    }

    .datepicker table tr td.range:active,
    .datepicker table tr td.range.active {
        color: #000;
        background-color: #d5d5d5;
        border-color: #9d9d9d;
    }

    .datepicker table tr td.range:active:hover,
    .datepicker table tr td.range.active:hover,
    .datepicker table tr td.range:active:focus,
    .datepicker table tr td.range.active:focus,
    .datepicker table tr td.range:active.focus,
    .datepicker table tr td.range.active.focus {
        color: #000;
        background-color: #c3c3c3;
        border-color: #7c7c7c;
    }

    .datepicker table tr td.range.disabled:hover,
    .datepicker table tr td.range[disabled]:hover,
    fieldset[disabled] .datepicker table tr td.range:hover,
    .datepicker table tr td.range.disabled:focus,
    .datepicker table tr td.range[disabled]:focus,
    fieldset[disabled] .datepicker table tr td.range:focus,
    .datepicker table tr td.range.disabled.focus,
    .datepicker table tr td.range[disabled].focus,
    fieldset[disabled] .datepicker table tr td.range.focus {
        background-color: #eeeeee;
        border-color: #bbbbbb;
    }

    .datepicker table tr td.range.focused {
        background: #d5d5d5;
    }

    .datepicker table tr td.range.disabled,
    .datepicker table tr td.range.disabled:active {
        background: #eeeeee;
        color: #777777;
    }

    .datepicker table tr td.range.highlighted {
        color: #000;
        background-color: #e4eef3;
        border-color: #9dc1d3;
    }

    .datepicker table tr td.range.highlighted:focus,
    .datepicker table tr td.range.highlighted.focus {
        color: #000;
        background-color: #c1d7e3;
        border-color: #4b88a6;
    }

    .datepicker table tr td.range.highlighted:hover {
        color: #000;
        background-color: #c1d7e3;
        border-color: #73a6c0;
    }

    .datepicker table tr td.range.highlighted:active,
    .datepicker table tr td.range.highlighted.active {
        color: #000;
        background-color: #c1d7e3;
        border-color: #73a6c0;
    }

    .datepicker table tr td.range.highlighted:active:hover,
    .datepicker table tr td.range.highlighted.active:hover,
    .datepicker table tr td.range.highlighted:active:focus,
    .datepicker table tr td.range.highlighted.active:focus,
    .datepicker table tr td.range.highlighted:active.focus,
    .datepicker table tr td.range.highlighted.active.focus {
        color: #000;
        background-color: #a8c8d8;
        border-color: #4b88a6;
    }

    .datepicker table tr td.range.highlighted.disabled:hover,
    .datepicker table tr td.range.highlighted[disabled]:hover,
    fieldset[disabled] .datepicker table tr td.range.highlighted:hover,
    .datepicker table tr td.range.highlighted.disabled:focus,
    .datepicker table tr td.range.highlighted[disabled]:focus,
    fieldset[disabled] .datepicker table tr td.range.highlighted:focus,
    .datepicker table tr td.range.highlighted.disabled.focus,
    .datepicker table tr td.range.highlighted[disabled].focus,
    fieldset[disabled] .datepicker table tr td.range.highlighted.focus {
        background-color: #e4eef3;
        border-color: #9dc1d3;
    }

    .datepicker table tr td.range.highlighted.focused {
        background: #c1d7e3;
    }

    .datepicker table tr td.range.highlighted.disabled,
    .datepicker table tr td.range.highlighted.disabled:active {
        background: #e4eef3;
        color: #777777;
    }

    .datepicker table tr td.range.today {
        color: #000;
        background-color: #f7ca77;
        border-color: #f1a417;
    }

    .datepicker table tr td.range.today:focus,
    .datepicker table tr td.range.today.focus {
        color: #000;
        background-color: #f4b747;
        border-color: #815608;
    }

    .datepicker table tr td.range.today:hover {
        color: #000;
        background-color: #f4b747;
        border-color: #bf800c;
    }

    .datepicker table tr td.range.today:active,
    .datepicker table tr td.range.today.active {
        color: #000;
        background-color: #f4b747;
        border-color: #bf800c;
    }

    .datepicker table tr td.range.today:active:hover,
    .datepicker table tr td.range.today.active:hover,
    .datepicker table tr td.range.today:active:focus,
    .datepicker table tr td.range.today.active:focus,
    .datepicker table tr td.range.today:active.focus,
    .datepicker table tr td.range.today.active.focus {
        color: #000;
        background-color: #f2aa25;
        border-color: #815608;
    }

    .datepicker table tr td.range.today.disabled:hover,
    .datepicker table tr td.range.today[disabled]:hover,
    fieldset[disabled] .datepicker table tr td.range.today:hover,
    .datepicker table tr td.range.today.disabled:focus,
    .datepicker table tr td.range.today[disabled]:focus,
    fieldset[disabled] .datepicker table tr td.range.today:focus,
    .datepicker table tr td.range.today.disabled.focus,
    .datepicker table tr td.range.today[disabled].focus,
    fieldset[disabled] .datepicker table tr td.range.today.focus {
        background-color: #f7ca77;
        border-color: #f1a417;
    }

    .datepicker table tr td.range.today.disabled,
    .datepicker table tr td.range.today.disabled:active {
        background: #f7ca77;
        color: #777777;
    }

    .datepicker table tr td.selected,
    .datepicker table tr td.selected.highlighted {
        color: #fff;
        background-color: #777777;
        border-color: #555555;
        text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);
    }

    .datepicker table tr td.selected:focus,
    .datepicker table tr td.selected.highlighted:focus,
    .datepicker table tr td.selected.focus,
    .datepicker table tr td.selected.highlighted.focus {
        color: #fff;
        background-color: #5e5e5e;
        border-color: #161616;
    }

    .datepicker table tr td.selected:hover,
    .datepicker table tr td.selected.highlighted:hover {
        color: #fff;
        background-color: #5e5e5e;
        border-color: #373737;
    }

    .datepicker table tr td.selected:active,
    .datepicker table tr td.selected.highlighted:active,
    .datepicker table tr td.selected.active,
    .datepicker table tr td.selected.highlighted.active {
        color: #fff;
        background-color: #5e5e5e;
        border-color: #373737;
    }

    .datepicker table tr td.selected:active:hover,
    .datepicker table tr td.selected.highlighted:active:hover,
    .datepicker table tr td.selected.active:hover,
    .datepicker table tr td.selected.highlighted.active:hover,
    .datepicker table tr td.selected:active:focus,
    .datepicker table tr td.selected.highlighted:active:focus,
    .datepicker table tr td.selected.active:focus,
    .datepicker table tr td.selected.highlighted.active:focus,
    .datepicker table tr td.selected:active.focus,
    .datepicker table tr td.selected.highlighted:active.focus,
    .datepicker table tr td.selected.active.focus,
    .datepicker table tr td.selected.highlighted.active.focus {
        color: #fff;
        background-color: #4c4c4c;
        border-color: #161616;
    }

    .datepicker table tr td.selected.disabled:hover,
    .datepicker table tr td.selected.highlighted.disabled:hover,
    .datepicker table tr td.selected[disabled]:hover,
    .datepicker table tr td.selected.highlighted[disabled]:hover,
    fieldset[disabled] .datepicker table tr td.selected:hover,
    fieldset[disabled] .datepicker table tr td.selected.highlighted:hover,
    .datepicker table tr td.selected.disabled:focus,
    .datepicker table tr td.selected.highlighted.disabled:focus,
    .datepicker table tr td.selected[disabled]:focus,
    .datepicker table tr td.selected.highlighted[disabled]:focus,
    fieldset[disabled] .datepicker table tr td.selected:focus,
    fieldset[disabled] .datepicker table tr td.selected.highlighted:focus,
    .datepicker table tr td.selected.disabled.focus,
    .datepicker table tr td.selected.highlighted.disabled.focus,
    .datepicker table tr td.selected[disabled].focus,
    .datepicker table tr td.selected.highlighted[disabled].focus,
    fieldset[disabled] .datepicker table tr td.selected.focus,
    fieldset[disabled] .datepicker table tr td.selected.highlighted.focus {
        background-color: #777777;
        border-color: #555555;
    }

    .datepicker table tr td.active,
    .datepicker table tr td.active.highlighted {
        color: #fff;
        background-color: #337ab7;
        border-color: #2e6da4;
        text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);
    }

    .datepicker table tr td.active:focus,
    .datepicker table tr td.active.highlighted:focus,
    .datepicker table tr td.active.focus,
    .datepicker table tr td.active.highlighted.focus {
        color: #fff;
        background-color: #286090;
        border-color: #122b40;
    }

    .datepicker table tr td.active:hover,
    .datepicker table tr td.active.highlighted:hover {
        color: #fff;
        background-color: #286090;
        border-color: #204d74;
    }

    .datepicker table tr td.active:active,
    .datepicker table tr td.active.highlighted:active,
    .datepicker table tr td.active.active,
    .datepicker table tr td.active.highlighted.active {
        color: #fff;
        background-color: #286090;
        border-color: #204d74;
    }

    .datepicker table tr td.active:active:hover,
    .datepicker table tr td.active.highlighted:active:hover,
    .datepicker table tr td.active.active:hover,
    .datepicker table tr td.active.highlighted.active:hover,
    .datepicker table tr td.active:active:focus,
    .datepicker table tr td.active.highlighted:active:focus,
    .datepicker table tr td.active.active:focus,
    .datepicker table tr td.active.highlighted.active:focus,
    .datepicker table tr td.active:active.focus,
    .datepicker table tr td.active.highlighted:active.focus,
    .datepicker table tr td.active.active.focus,
    .datepicker table tr td.active.highlighted.active.focus {
        color: #fff;
        background-color: #204d74;
        border-color: #122b40;
    }

    .datepicker table tr td.active.disabled:hover,
    .datepicker table tr td.active.highlighted.disabled:hover,
    .datepicker table tr td.active[disabled]:hover,
    .datepicker table tr td.active.highlighted[disabled]:hover,
    fieldset[disabled] .datepicker table tr td.active:hover,
    fieldset[disabled] .datepicker table tr td.active.highlighted:hover,
    .datepicker table tr td.active.disabled:focus,
    .datepicker table tr td.active.highlighted.disabled:focus,
    .datepicker table tr td.active[disabled]:focus,
    .datepicker table tr td.active.highlighted[disabled]:focus,
    fieldset[disabled] .datepicker table tr td.active:focus,
    fieldset[disabled] .datepicker table tr td.active.highlighted:focus,
    .datepicker table tr td.active.disabled.focus,
    .datepicker table tr td.active.highlighted.disabled.focus,
    .datepicker table tr td.active[disabled].focus,
    .datepicker table tr td.active.highlighted[disabled].focus,
    fieldset[disabled] .datepicker table tr td.active.focus,
    fieldset[disabled] .datepicker table tr td.active.highlighted.focus {
        background-color: #337ab7;
        border-color: #2e6da4;
    }

    .datepicker table tr td span {
        display: block;
        width: 23%;
        height: 54px;
        line-height: 54px;
        float: left;
        margin: 1%;
        cursor: pointer;
        border-radius: 4px;
    }

    .datepicker table tr td span:hover,
    .datepicker table tr td span.focused {
        background: #eeeeee;
    }

    .datepicker table tr td span.disabled,
    .datepicker table tr td span.disabled:hover {
        background: none;
        color: #777777;
        cursor: default;
    }

    .datepicker table tr td span.active,
    .datepicker table tr td span.active:hover,
    .datepicker table tr td span.active.disabled,
    .datepicker table tr td span.active.disabled:hover {
        color: #fff;
        background-color: #337ab7;
        border-color: #2e6da4;
        text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);
    }

    .datepicker table tr td span.active:focus,
    .datepicker table tr td span.active:hover:focus,
    .datepicker table tr td span.active.disabled:focus,
    .datepicker table tr td span.active.disabled:hover:focus,
    .datepicker table tr td span.active.focus,
    .datepicker table tr td span.active:hover.focus,
    .datepicker table tr td span.active.disabled.focus,
    .datepicker table tr td span.active.disabled:hover.focus {
        color: #fff;
        background-color: #286090;
        border-color: #122b40;
    }

    .datepicker table tr td span.active:hover,
    .datepicker table tr td span.active:hover:hover,
    .datepicker table tr td span.active.disabled:hover,
    .datepicker table tr td span.active.disabled:hover:hover {
        color: #fff;
        background-color: #286090;
        border-color: #204d74;
    }

    .datepicker table tr td span.active:active,
    .datepicker table tr td span.active:hover:active,
    .datepicker table tr td span.active.disabled:active,
    .datepicker table tr td span.active.disabled:hover:active,
    .datepicker table tr td span.active.active,
    .datepicker table tr td span.active:hover.active,
    .datepicker table tr td span.active.disabled.active,
    .datepicker table tr td span.active.disabled:hover.active {
        color: #fff;
        background-color: #286090;
        border-color: #204d74;
    }

    .datepicker table tr td span.active:active:hover,
    .datepicker table tr td span.active:hover:active:hover,
    .datepicker table tr td span.active.disabled:active:hover,
    .datepicker table tr td span.active.disabled:hover:active:hover,
    .datepicker table tr td span.active.active:hover,
    .datepicker table tr td span.active:hover.active:hover,
    .datepicker table tr td span.active.disabled.active:hover,
    .datepicker table tr td span.active.disabled:hover.active:hover,
    .datepicker table tr td span.active:active:focus,
    .datepicker table tr td span.active:hover:active:focus,
    .datepicker table tr td span.active.disabled:active:focus,
    .datepicker table tr td span.active.disabled:hover:active:focus,
    .datepicker table tr td span.active.active:focus,
    .datepicker table tr td span.active:hover.active:focus,
    .datepicker table tr td span.active.disabled.active:focus,
    .datepicker table tr td span.active.disabled:hover.active:focus,
    .datepicker table tr td span.active:active.focus,
    .datepicker table tr td span.active:hover:active.focus,
    .datepicker table tr td span.active.disabled:active.focus,
    .datepicker table tr td span.active.disabled:hover:active.focus,
    .datepicker table tr td span.active.active.focus,
    .datepicker table tr td span.active:hover.active.focus,
    .datepicker table tr td span.active.disabled.active.focus,
    .datepicker table tr td span.active.disabled:hover.active.focus {
        color: #fff;
        background-color: #204d74;
        border-color: #122b40;
    }

    .datepicker table tr td span.active.disabled:hover,
    .datepicker table tr td span.active:hover.disabled:hover,
    .datepicker table tr td span.active.disabled.disabled:hover,
    .datepicker table tr td span.active.disabled:hover.disabled:hover,
    .datepicker table tr td span.active[disabled]:hover,
    .datepicker table tr td span.active:hover[disabled]:hover,
    .datepicker table tr td span.active.disabled[disabled]:hover,
    .datepicker table tr td span.active.disabled:hover[disabled]:hover,
    fieldset[disabled] .datepicker table tr td span.active:hover,
    fieldset[disabled] .datepicker table tr td span.active:hover:hover,
    fieldset[disabled] .datepicker table tr td span.active.disabled:hover,
    fieldset[disabled] .datepicker table tr td span.active.disabled:hover:hover,
    .datepicker table tr td span.active.disabled:focus,
    .datepicker table tr td span.active:hover.disabled:focus,
    .datepicker table tr td span.active.disabled.disabled:focus,
    .datepicker table tr td span.active.disabled:hover.disabled:focus,
    .datepicker table tr td span.active[disabled]:focus,
    .datepicker table tr td span.active:hover[disabled]:focus,
    .datepicker table tr td span.active.disabled[disabled]:focus,
    .datepicker table tr td span.active.disabled:hover[disabled]:focus,
    fieldset[disabled] .datepicker table tr td span.active:focus,
    fieldset[disabled] .datepicker table tr td span.active:hover:focus,
    fieldset[disabled] .datepicker table tr td span.active.disabled:focus,
    fieldset[disabled] .datepicker table tr td span.active.disabled:hover:focus,
    .datepicker table tr td span.active.disabled.focus,
    .datepicker table tr td span.active:hover.disabled.focus,
    .datepicker table tr td span.active.disabled.disabled.focus,
    .datepicker table tr td span.active.disabled:hover.disabled.focus,
    .datepicker table tr td span.active[disabled].focus,
    .datepicker table tr td span.active:hover[disabled].focus,
    .datepicker table tr td span.active.disabled[disabled].focus,
    .datepicker table tr td span.active.disabled:hover[disabled].focus,
    fieldset[disabled] .datepicker table tr td span.active.focus,
    fieldset[disabled] .datepicker table tr td span.active:hover.focus,
    fieldset[disabled] .datepicker table tr td span.active.disabled.focus,
    fieldset[disabled] .datepicker table tr td span.active.disabled:hover.focus {
        background-color: #337ab7;
        border-color: #2e6da4;
    }

    .datepicker table tr td span.old,
    .datepicker table tr td span.new {
        color: #777777;
    }

    .datepicker .datepicker-switch {
        width: 145px;
    }

    .datepicker .datepicker-switch,
    .datepicker .prev,
    .datepicker .next,
    .datepicker tfoot tr th {
        cursor: pointer;
    }

    .datepicker .datepicker-switch:hover,
    .datepicker .prev:hover,
    .datepicker .next:hover,
    .datepicker tfoot tr th:hover {
        background: #eeeeee;
    }

    .datepicker .prev.disabled,
    .datepicker .next.disabled {
        visibility: hidden;
    }

    .datepicker .cw {
        font-size: 10px;
        width: 12px;
        padding: 0 2px 0 5px;
        vertical-align: middle;
    }

    .input-group.date .input-group-addon {
        cursor: pointer;
    }

    .input-daterange {
        width: 100%;
    }

    .input-daterange input {
        text-align: center;
    }

    .input-daterange input:first-child {
        border-radius: 3px 0 0 3px;
    }

    .input-daterange input:last-child {
        border-radius: 0 3px 3px 0;
    }

    .input-daterange .input-group-addon {
        width: auto;
        min-width: 16px;
        padding: 4px 5px;
        line-height: 1.42857143;
        border-width: 1px 0;
        margin-left: -5px;
        margin-right: -5px;
    }

    .dropdown-menu {
        display: block !important;
    }


    /*# sourceMappingURL=bootstrap-datepicker3.css.map */
</style>